import React, { FunctionComponent } from 'react'
import { WidgetBase } from 'Shared/components/builders/WidgetBuilder'
import WidgetContainer from 'Shared/components/builders/WidgetContainer'

import EasySoftwareBenefits, {
  EasySoftwareBenefitsType,
} from '../EasySoftwareBenefits/EasySoftwareBenefits'

export interface WidgetEasySoftwareBenefitsType
  extends WidgetBase,
  EasySoftwareBenefitsType {
  contentType: 'EasySoftwareBenefits'
}

const WidgetEasySoftwareBenefits: FunctionComponent<WidgetEasySoftwareBenefitsType> = (
  props
) => (
  <WidgetContainer {...props.puxWidgetProperties} {...props.metadata}>
    <EasySoftwareBenefits
      displayText={props.displayText}
      benefitsList={props.benefitsList}
    />
  </WidgetContainer>
)

export default WidgetEasySoftwareBenefits
